import { render } from "./HeroiconsOutlineTerminal.vue?vue&type=template&id=7a15f79c"
const script = {}

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineTerminal.vue"]])

export default __exports__